import dayjs from 'dayjs';
import { t } from 'i18next';
import * as yup from 'yup';

import { MAX_RANGE_DAYS } from './utils';

export const submitOrderLogSchema = () =>
  yup.object({
    dateFrom: yup.mixed().nullable().label(t('labelDateFrom')),
    dateTo: yup
      .mixed()
      .nullable()
      .label(t('labelDateTo'))
      .test(
        'submitOrderLogDateRange',
        t('messageInvalidDateRangeMaxDays', { maxDays: MAX_RANGE_DAYS }),
        function (value) {
          const { dateFrom } = this.parent;

          if (!value || !dateFrom) {
            return true;
          }

          const from = dayjs(dateFrom);
          const to = dayjs(value);

          return !to.isBefore(from, 'day') && to.diff(from, 'day') < MAX_RANGE_DAYS;
        }
      ),
  });
